;(function ($) {

    $.fn.directDebitForm = function (options) {


        var form = this,
            triggers = form.find('#input_3_5'),
            submitButton = form.find('#gform_submit_button_3');

        var init = function () {

            toggleDownloadButton();

        };

        var toggleDownloadButton = function () {
            if ($('#choice_3_5_1').is(':checked')) {
                submitButton.val('Download Direct Debit Form');
                form.find('.gform_footer').addClass('account-holder');
            } else {
                submitButton.val('Continue & Subscribe');
                form.find('.gform_footer').removeClass('account-holder');

            }
        };

        triggers.on('change', 'input', function (event) {

            toggleDownloadButton();

        });

        form.on('submit', function(event) {
            if ($('#choice_3_5_1').is(':checked')) {
                event.preventDefault();

                window.location = $('#field_3_6').find('a').attr('href');
            }

        });

        init();

        return this;

    };


})(jQuery);